import { buildMatchPath } from "pages/PageConfigs";
import { CenterFlexColumn } from "styles/layout";
import { SwissMatchCell, SwissMatchTeamLogoContainer } from "./styles";
import { Match, getWinningRosterIds } from "model/Match/Match";
import { getRosterId, Roster } from "model/Roster/Roster";
import { getRosterDisplayScore } from "model/Match/MatchScore";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { PlainNavLink } from "styles/elements";

interface Props {
  match: Match;
  rosterId: string;
  tournamentId: string;
}

export const SwissTableMatchResult = ({
  match,
  rosterId,
  tournamentId,
}: Props) => {
  const oppositionRoster = (match.teams.rosters as Roster[]).find(
    (r) => getRosterId(r) !== rosterId
  );
  const oppositionRosterId = !!oppositionRoster
    ? getRosterId(oppositionRoster)
    : undefined;

  const winningRosterIds = getWinningRosterIds(match);
  const rosterScoreString = getRosterDisplayScore(match, rosterId);
  const oppScoreString = !!oppositionRosterId
    ? getRosterDisplayScore(match, oppositionRosterId)
    : undefined;

  const matchScore = `${rosterScoreString ?? "-"} - ${oppScoreString ?? "-"}`;

  return (
    <SwissMatchCell winningTeam={winningRosterIds?.includes(rosterId) ?? false}>
      <PlainNavLink to={buildMatchPath(match.id)}>
        <CenterFlexColumn>
          <SwissMatchTeamLogoContainer>
            {!!oppositionRosterId && (
              <RosterOrgLogo
                rosterId={oppositionRosterId}
                tournamentId={tournamentId}
              />
            )}
          </SwissMatchTeamLogoContainer>
          {matchScore}
        </CenterFlexColumn>
      </PlainNavLink>
    </SwissMatchCell>
  );
};
